import { DependencyLink } from './types';

export const DEMO_LINKS: DependencyLink[] = [
  { from: 'cdn', to: 'api-gateway', value: 0.0008 },
  { from: 'cdn', to: 'web-bff', value: 0.0005 },
  { from: 'api-gateway', to: 'web-bff', value: 0.0009 },
  { from: 'api-gateway', to: 'mobile-bff', value: 0.0007 },

  { from: 'web-bff', to: 'auth-service', value: 0.0006 },
  { from: 'web-bff', to: 'users-service', value: 0.0009 },
  { from: 'web-bff', to: 'products-service', value: 0.024 },
  { from: 'web-bff', to: 'cart-service', value: 0.0011 },
  { from: 'web-bff', to: 'orders-service', value: 0.0014 },
  { from: 'web-bff', to: 'search-service', value: 0.0009 },
  { from: 'web-bff', to: 'recommendations-service', value: 0.018 },
  { from: 'web-bff', to: 'feature-flags-service', value: 0.0004 },

  { from: 'mobile-bff', to: 'auth-service', value: 0.0007 },
  { from: 'mobile-bff', to: 'users-service', value: 0.0008 },
  { from: 'mobile-bff', to: 'cart-service', value: 0.0009 },
  { from: 'mobile-bff', to: 'orders-service', value: 0.0011 },
  { from: 'mobile-bff', to: 'notifications-service', value: 0.063 },
  { from: 'mobile-bff', to: 'feature-flags-service', value: 0.0005 },

  { from: 'websocket-gateway', to: 'notifications-service', value: 0.082 },

  { from: 'auth-service', to: 'users-service', value: 0.0008 },
  { from: 'users-service', to: 'accounts-service', value: 0.0009 },

  { from: 'products-service', to: 'catalog-service', value: 0.014 },
  { from: 'products-service', to: 'reviews-service', value: 0.18 },
  { from: 'products-service', to: 'pricing-service', value: 0.013 },
  { from: 'search-service', to: 'catalog-service', value: 0.0008 },
  { from: 'cart-service', to: 'products-service', value: 0.022 },
  { from: 'cart-service', to: 'pricing-service', value: 0.0007 },

  { from: 'recommendations-service', to: 'products-service', value: 0.014 },
  { from: 'reviews-service', to: 'recommendations-service', value: 0.16 },

  { from: 'accounts-service', to: 'postgres-primary', value: 0.012 },
  { from: 'catalog-service', to: 'postgres-primary', value: 0.014 },

  { from: 'orders-service', to: 'payments-service', value: 0.0012 },
  { from: 'orders-service', to: 'shipping-service', value: 0.0008 },
  { from: 'orders-service', to: 'inventory-service', value: 0.0007 },
  { from: 'orders-service', to: 'notifications-service', value: 0.071 },
  { from: 'orders-service', to: 'kafka-broker', value: 0.0009 },
  { from: 'payments-service', to: 'fraud-service', value: 0.0006 },
  { from: 'payments-service', to: 'ledger-service', value: 0.0008 },
  { from: 'payments-service', to: 'tax-service', value: 0.0005 },
  { from: 'payments-service', to: 'audit-service', value: 0.0007 },
  { from: 'payments-service', to: 'delivery-receipts-service', value: 0.0001 },
  { from: 'shipping-service', to: 'inventory-service', value: 0.0006 },
  { from: 'ledger-service', to: 'postgres-primary', value: 0.012 },
  { from: 'audit-service', to: 'kafka-broker', value: 0.012 },
  { from: 'analytics-service', to: 'kafka-broker', value: 0.0014 },

  { from: 'payments-service', to: 'orders-service', value: 0.0011 },
  { from: 'kafka-broker', to: 'analytics-service', value: 0.0014 },

  { from: 'notifications-service', to: 'email-service', value: 0.12 },
  { from: 'notifications-service', to: 'sms-service', value: 0.0014 },
  { from: 'notifications-service', to: 'push-service', value: 0.0009 },
  { from: 'notifications-service', to: 'in-app-service', value: 0.0011 },
  { from: 'notifications-service', to: 'voice-service', value: 0.0006 },
  { from: 'notifications-service', to: 'webhook-service', value: 0.0008 },

  { from: 'email-service', to: 'notifications-service', value: 0.034 },
  { from: 'push-service', to: 'notifications-service', value: 0.0008 },
  { from: 'in-app-service', to: 'notifications-service', value: 0.0007 },
  { from: 'webhook-service', to: 'notifications-service', value: 0.0006 },
  { from: 'delivery-receipts-service', to: 'notifications-service', value: 0.012 },

  { from: 'staging-lb', to: 'staging-api', value: 0.0009 },
  { from: 'staging-lb', to: 'staging-web', value: 0.0007 },
  { from: 'staging-api', to: 'staging-orders', value: 0.0008 },
  { from: 'staging-api', to: 'staging-users', value: 0.0006 },
  { from: 'staging-web', to: 'staging-users', value: 0.0005 },
  { from: 'staging-orders', to: 'staging-payments', value: 0.022 },
  { from: 'staging-orders', to: 'staging-postgres', value: 0.0007 },
  { from: 'staging-users', to: 'staging-postgres', value: 0.0008 },
  { from: 'staging-payments', to: 'staging-postgres', value: 0.0006 },

  { from: 'test-runner', to: 'test-api', value: 0.0004 },
  { from: 'test-runner', to: 'test-worker', value: 0.0003 },
  { from: 'test-api', to: 'test-db', value: 0.0003 },
];
